/*
 * @Author: Teemo Ding
 * @Date: 2021-10-22 11:39:35
 * @LastEditTime: 2022-06-10 14:02:11
 * @LastEditors: Json Chen
 * @FilePath: /unifyxp-v2-store-portal/src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelMiniProgramSetting/MiniProgramCodeReview/index.tsx
 */
import { Alert, SizeFittingTable } from '@/src/components/Antd';
import ModalFooter from '@/src/components/Antd/Modal/ModalFooter';
import SectionWrapper from '@/src/components/Layouts/Section/SectionWrapper';
import { request_release } from '@/src/request/salesChannel/setting/miniProgramSetting';
import { Icon } from '@/src/tools/icon';
import { Status } from '@/src/types/common/miniProgram';
import { useRequest } from 'ahooks';
import React, { useState } from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import Tip from 'src/pages/SalesCannelVersion/SalesChannelSettings/SalesChannelCheckout/Components/DisabledSectionTip';
import { i18nGet, replaceI18nVariables } from 'src/tools/tools';
import { reviewColumns } from '../config';
import css from '../css.module.less';
import css1 from './css.module.less';
const MiniProgramCodeReview = ({
  review,
  setShowModal,
  setModalTitle,
  setModalContent,
  runLandingPage,
  disabled,
}) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const [fold, setFold] = useState(false);

  const { run: runRelease } = useRequest((data) => request_release(data), {
    manual: true,
    ready: !disabled,
    onSuccess: () => {
      setShowModal(false);
      runLandingPage();
    },
  });

  const releaseModal = (uuid) => {
    setShowModal(true);
    setModalTitle(
      getI18n('salesChannelMiniProgramSettings.index.releaseCodeVersion'),
    );
    setModalContent(
      <div>
        <p className={css.boundProgramSuccess}>
          {getI18n(
            'salesChannelMiniProgramSettings.index.releaseCodeVersionContent',
          )}
        </p>
        <ModalFooter
          onOk={() => runRelease(uuid)}
          okText={getI18n('salesChannelMiniProgramSettings.index.release')}
          onCancel={() => setShowModal(false)}
        />
      </div>,
    );
  };

  const renderAlert = (statusItem) =>
    statusItem == Status.Rejected || statusItem == Status.Processing ? (
      <Alert
        className={css.certificateAlert}
        closable={statusItem == Status.Processing ? false : true}
        message={
          statusItem == Status.Processing
            ? getI18n(
                'salesChannelMiniProgramSettings.index.codeVersionReviewProcessing',
              )
            : getI18n(
                'salesChannelMiniProgramSettings.index.codeVersionReviewRejected',
              )
        }
        showIcon
        type={statusItem == Status.Processing ? 'info' : 'error'}
        icon={
          <Icon
            type={
              statusItem == Status.Processing ? 'iconpending' : 'iconfailed'
            }></Icon>
        }
        description={
          statusItem == Status.Processing
            ? getI18n(
                'salesChannelMiniProgramSettings.index.codeVersionReviewProcessingDesc',
              )
            : replaceI18nVariables(
                getI18n(
                  'salesChannelMiniProgramSettings.index.codeVersionReviewRejectedDesc',
                ),
                (review || {}).remarks,
              )
        }
      />
    ) : null;

  //TODO Alert处理（需要其他status）
  return (
    <SectionWrapper
      titleClassName={css.titleContainer}
      containerClassName={css.logoWrapper}
      titleOnClick={() => setFold(!fold)}
      hideContent={!fold}
      rightPart={<Icon type={fold ? 'icondown1' : 'iconright'} />}
      title={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramCodeReviewByTencent',
      )}
      subtitle={getI18n(
        'salesChannelMiniProgramSettings.index.miniProgramCodeReviewByTencentDesc',
      )}>
      {renderAlert((review || {}).status)}
      <h3>
        {getI18n(
          'salesChannelMiniProgramSettings.index.codeVersionReviewSubmission',
        )}
      </h3>
      <p>
        {getI18n(
          'salesChannelMiniProgramSettings.index.codeVersionReviewSubmissionDesc',
        )}
      </p>
      <SizeFittingTable
        rowKey='uuid'
        pagination={false}
        id='codeVersionPreview'
        columns={reviewColumns(releaseModal, disabled, { getI18n })}
        dataSource={review ? [review] : []}
        rowSelection={false}
      />
      <Tip
        className={css1.tip}
        tip={
          <span>
            <span>
              {getI18n(
                'salesChannelMiniProgramSettings.index.miniProgramPortalDesc',
              )}
            </span>
            <span className={css1.attention}>
              {getI18n(
                'salesChannelMiniProgramSettings.index.miniProgramPortal',
              )}
            </span>
            <span>{'> 开发设置 > 服务器域名 > 修改.'}</span>
          </span>
        }
      />
    </SectionWrapper>
  );
};

export default MiniProgramCodeReview;
